export const getStickyATCElement = () => {
  // Query elements matching the markup added by the Sticky component
  const buyboxMatch = document.querySelector(
    'div[data-component^=buybox\\:Buybox\\:v] [style^=min-height] > [class*=sticky]'
  );
  const applianceBuyboxMatch = document.querySelector(
    'div[data-component^=buybox\\:MajorApplianceBuyBox\\:v] [style^=min-height] > [class*=sticky]'
  );
  const buyboxActionsMatch = document.querySelector(
    'div[data-component^=buybox\\:BuyboxActions\\:v] [style^=min-height] > [class*=sticky]'
  );
  const buyboxSimpleMatch = document.querySelector(
    'div[data-component^=Buybox] [style^=min-height] > [class*=sticky]'
  );

  // Use the more specific section if available
  if (buyboxActionsMatch) return buyboxActionsMatch;

  if (applianceBuyboxMatch) return applianceBuyboxMatch;

  if (buyboxSimpleMatch) return buyboxSimpleMatch;

  // Use the generic (older) version as fallback
  if (buyboxMatch) return buyboxMatch;

  return null;
};

export const nrTrack = (actionName, actionObject) => {
  if (typeof window !== 'undefined' && window.newrelic && actionName) {
    window.newrelic.addPageAction(actionName, actionObject);
  }
};
